export default {
  title: '短信营销通道',

  // 表单相关
  form: {
    phoneCode: '电话区号',
    phoneCodePlaceholder: '请输入电话区号',
    channelName: '通道名称',
    channelNamePlaceholder: '请输入通道名称',
    country: '国家',
    countryPlaceholder: '请选择国家',
    status: '状态',
    statusPlaceholder: '请选择状态',
    currency: '币种',
    currencyPlaceholder: '请选择币种',
    cost: '单价',
    costPlaceholder: '请输入单价',
    remark: '备注',
    remarkPlaceholder: '请输入备注'
  },

  // 表格相关
  table: {
    channelName: '通道名',
    country: '国家',
    cost: '单价',
    currency: '币种',
    status: '状态',
    remark: '备注',
    actions: '操作'
  },

  // 状态相关
  status: {
    enabled: '启用',
    disabled: '禁用'
  },

  // 弹窗相关
  modal: {
    editTitle: '编辑短信通道'
  },

  // 验证相关
  validation: {
    channelNameRequired: '请输入通道名称',
    countryRequired: '请选择国家',
    phoneCodeRequired: '请输入电话区号',
    currencyRequired: '请选择币种',
    costRequired: '请输入单价',
    costMin: '单价不能小于0',
    statusRequired: '请选择状态'
  },

  // 消息相关
  message: {
    queryFailed: '查询失败',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    statusUpdateSuccess: '状态更新成功',
    statusUpdateFailed: '状态更新失败'
  },

  // 确认相关
  confirm: {
    toggleStatus: '确定要切换此通道的状态吗？'
  },

  // 分页相关
  pagination: {
    total: '共 {{total}} 条记录'
  }
};
